export default "/images/topdanmark.png?3f74f5874a994db9f484c17a4df258e4";